export const ContactUs = () => (
	<div className="policy-container">
		<h1>Contact Us</h1>
		<p>We are here to help you 24/7. Reach out to us via any channel below:</p>
		<div className="contact-details">
			<p><strong>Phone/WhatsApp:</strong> <a href="tel:+917899295998">+91 7899295998</a></p>
			<p><strong>Email:</strong> <a href="mailto:contact@mybharatservice.com">contact@mybharatservice.com</a></p>
			<p><strong>Support Hours:</strong> Monday - Sunday (Open 24 Hours)</p>
		</div>
		{/* Footer for Legal Connection */}
		<footer style={{ marginTop: '30px', borderTop: '1px solid #ddd', paddingTop: '10px', fontSize: '0.85rem' }}>
			<p>MyBharatService is a registered brand name of <strong>CITIKART ONLINE SERVICE PRIVATE LIMITED</strong>. All rights reserved.</p>
		</footer>
	</div>
);
